import checkIfOutputIsVisible from "./checkIfOutputIsVisible";
import evaluateBlockDependencies from "./evaluateBlockDependencies";
import getExpressionConfiguration from "./getExpressionConfiguration";
import {getActive} from "./getActive";

const checkIfBlockIsVisible = (
  block,
  context,
  recursiveResponsesIndex=undefined,
  skipContextChecks=false,
) => {
  if (!getActive(block, context)) {
    return false;
  }
  const dependencies = getExpressionConfiguration(block, context, 'dependencies');

  if (
    !dependencies?.length ||
    evaluateBlockDependencies(dependencies, context, false, recursiveResponsesIndex)
  ) {
    if (block.type === "output") {
      return checkIfOutputIsVisible(block, context, skipContextChecks);
    }

    return true;
  }

  return false;
};

export default checkIfBlockIsVisible;
